var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ly-data-center', { 'ly-data-center--micro': _vm.isMicroAppMode }],attrs:{"id":"app"}},[_c('router-view'),_c('div',{attrs:{"id":"tools-affix"}},[_c('PdfToImage')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }